import React, { useState } from 'react'
import { NavigateFn } from '@reach/router'
import { UseBookingsHook, Filters } from './hooks/useBookings'
import Toolbar from './Toolbar'
import { useAppData } from '@providers'
import { useUser } from '@hooks'
import { bookableDesks } from '@utils'
import { CurrentBookingsTable } from '../CurrentBookingsTable'
import createBookingColumns from './createColumns'

export default function Tableview({
  bookings,
  navigate,
}: {
  bookings: UseBookingsHook
  navigate?: NavigateFn
}) {
  const {
    types: { usageType: usageTypes },
    product: { features },
  } = useAppData()
  const { user } = useUser()
  const [showFilters, setShowFilters] = useState(true)
  const bookableTypes = new Set(bookableDesks)
  const enableHealthScreening = user?.company.settings.enableHealthScreening || false

  const columns = createBookingColumns({
    navigate,
    features,
    enableHealthScreening,
  })

  return (
    <>
      <Toolbar
        {...bookings}
        navigate={navigate}
        usageTypeIds={usageTypes.filter((ut) => bookableTypes.has(ut.name)).map((ut) => ut.id)}
        showFilters={showFilters}
        setShowFilters={setShowFilters}
      />
      <CurrentBookingsTable<Filters, UseBookingsHook>
        bookingHook={bookings}
        columns={columns}
        showFilters={showFilters}
      />
    </>
  )
}
